import {getLearnMoreLinkHref} from 'shells/billing/add-ons/helpers';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import {AddOnCard} from './add-on-card';
import {ADD_ONS_CONFIG} from './consts';

import styles from './trial-summary-page.module.css';

interface Props {
    onOpenCampaignsModal: () => void;
}

export function TrialSummaryAddOns(props: Props) {
    return (
        <Stack spacing={16}>
            <div className={styles['add-ons-section']}>
                <Stack spacing={4}>
                    <Body size='xlarge' isBold={true} useDoyle={true} color='dark'>
                        Looking for even more?
                    </Body>
                    <Body>
                        Explore our powerful add-ons for the ultimate all-in-one experience!
                    </Body>
                </Stack>
                <div className={styles['add-ons-grid']}>
                    {ADD_ONS_CONFIG.map((item) => {
                        const href =
                            'hrefKey' in item && item.hrefKey
                                ? getLearnMoreLinkHref(item.hrefKey)
                                : undefined;
                        const onOpenModal =
                            'useModal' in item && item.useModal
                                ? props.onOpenCampaignsModal
                                : undefined;
                        return (
                            <AddOnCard
                                key={item.title}
                                title={item.title}
                                description={item.description}
                                illustrationSrc={item.illustrationSrc}
                                onOpenModal={onOpenModal}
                                href={href}
                            />
                        );
                    })}
                </div>
            </div>
        </Stack>
    );
}
